import { useState } from "react";
import { YouTubeVideoInput } from "../ui/forms/files/YouTubeVideoInput";
import { toPlayerOption } from "../ui/forms/dropdown/ddLabels";

import { searchPlayers } from "../../services/playersAPI";
import { AsyncDropdown } from "../ui/forms/dropdown/AsyncDropdown";
import { createFight } from "../../services/fightsAPI";
import { toast } from "react-toastify";

export const CreateFight = ({ gameInfo, fetchGame, closeModel }) => {
  const [isPending, setIsPending] = useState(false);
  const [formData, setFormData] = useState({
    // season: '',
    fightType: "",
    time: "",
    description: "",
    tookPlaceAt: "",
    // league: '',
    player1: "",
    player2: "",
  });
  const [youTubeUrl, setYouTubeUrl] = useState("");

  const handleChange = (input) => {
    if (input.target) {
      // Standard HTML input handling
      const { name, value } = input.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      // react-select input handling, assuming input is { value, label }
      const { name, value } = input;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleDropdownChange = (selectedOption, name) => {
    handleChange({ name, value: selectedOption ? selectedOption.value : "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate
    if (
      !formData.fightType ||
      !formData.time ||
      !formData.tookPlaceAt ||
      !formData.player1 ||
      !formData.player2
    ) {
      toast.error("All fields are required", { autoClose: 5000 });
      return;
    }

    // Create a new FormData object
    const formDataToSend = new FormData();

    // Append form data fields
    formDataToSend.append("fightType", formData.fightType);
    formDataToSend.append("time", formData.time);
    formDataToSend.append("tookPlaceAt", formData.tookPlaceAt);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("player1", formData.player1);
    formDataToSend.append("player2", formData.player2);
    formDataToSend.append("videoLink", youTubeUrl);
    //append game data
    formDataToSend.append("game", gameInfo.GameID);
    formDataToSend.append("league", gameInfo.LeagueDetails.LeagueID);
    formDataToSend.append("season", gameInfo.SeasonDetails.SeasonID);
    formDataToSend.append("date", gameInfo.date);

    //event description???
    // formDataToSend.forEach((value, key) => {
    //     console.log(`${key}: ${value}`);
    // });

    try {
      setIsPending(true);
      let response = await createFight(formDataToSend);
      if (response?.success) {
        toast.success("Fight created successfully");
        if (closeModel) closeModel();
        if (fetchGame) fetchGame();
      } else {
        toast.error("Error creating fight", { autoClose: 5000 });
      }
      setIsPending(false);
    } catch (error) {
      toast.error("Error creating fight", { autoClose: 5000 });
      setIsPending(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Create Fight</h1>
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded shadow-lg w-full max-w-md"
      >
        {/* <BasicDropdown
                    name='season'
                    placeholder='Select a Season'
                    handleChange={handleDropdownChange}
                    isSearchable={true}
                    apiFunction={getAllSeasons}
                    toOptionLabel={toSeasonOption}
                /> */}
        <input
          type="text"
          name="fightType"
          value={formData.fightType}
          onChange={handleChange}
          placeholder="Enter Fight Type"
          className="px-4 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 rounded w-full mb-4"
        />
        <input
          type="text"
          name="time"
          value={formData.time}
          onChange={handleChange}
          placeholder="Enter Time Of Fight"
          className="px-4 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 rounded w-full mb-4"
        />
        <input
          type="text"
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="Enter Description"
          className="px-4 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 rounded w-full mb-4"
        />
        <input
          type="text"
          name="tookPlaceAt"
          value={formData.tookPlaceAt}
          onChange={handleChange}
          placeholder="Enter Where the Fight Took Place"
          className="px-4 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 rounded w-full mb-4"
        />
        {/* <BasicDropdown
                    name='league'
                    placeholder='Select a League'
                    handleChange={handleDropdownChange}
                    isSearchable={true}
                    apiFunction={getDDLeagueNames}
                    toOptionLabel={toLeagueOption}
                /> */}
        <AsyncDropdown
          name="player1"
          placeholder="Select a Player"
          handleChange={handleDropdownChange}
          isSearchable={true}
          apiFunction={searchPlayers}
          toOptionLabel={toPlayerOption}
        />
        <div className="mb-4"></div>
        <AsyncDropdown
          name="player2"
          placeholder="Select a Player"
          handleChange={handleDropdownChange}
          isSearchable={true}
          apiFunction={searchPlayers}
          toOptionLabel={toPlayerOption}
        />
        <div className="mb-4"></div>
        <YouTubeVideoInput setYouTubeUrl={setYouTubeUrl} />
        <button
          type="submit"
          className="px-4 py-2 bg-orange-500 text-white font-bold rounded hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50 w-full"
          disabled={isPending}
        >
          {isPending ? "Creating Fight..." : "Create Fight"}
        </button>
      </form>
    </div>
  );
};
